import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import type VueI18n from 'vue-i18n';

type Item = { value: string };
type CustomErrorMessages = Record<string, string>;
type InputMode = 'text' | 'tel' | 'email';

type Props = {
  items?: Item[];
  label?: string;
  inputId?: string;
  inputType?: string;
  inputMode?: InputMode;
  placeholder?: string;
  error?: any; // Vuelidate-like shape
  customErrorMessages?: CustomErrorMessages;
  addRequiredStar?: boolean;
  value?: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'text-dropdown',
  props: {
    items: { default: () => [] },
    label: { default: '' },
    inputId: { default: '' },
    inputType: { default: 'text' },
    inputMode: { default: 'text' },
    placeholder: { default: '' },
    error: { default: () => ({}) },
    customErrorMessages: { default: () => ({}) },
    addRequiredStar: { type: Boolean, default: false },
    value: { default: '' }
  },
  emits: ["input", "focus", "blur"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: string): void;
  (e: 'focus'): void;
  (e: 'blur'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { items: Item[], label: string, inputId: string, inputType: string, inputMode: InputMode, placeholder: string, error: any, customErrorMessages: CustomErrorMessages, addRequiredStar: boolean, value: string };

const IconArrowDown = () => import('@white-label-icon/icon-arrow-down');

// Props




// State
const open = ref(false);

// Computed
const errorExists = computed<boolean>(() => Boolean(props.error && props.error.$error));

function getErrorState(): string {
  if (!props.error?.$error) return '';
  const validationFields = Object.entries(props.error).filter(([key]) => key[0] !== '$');
  const foundField = validationFields.find(([, value]) => !value);
  return foundField ? foundField[0] : '';
}

function getErrorMessage(errorName: string): string {
  if (!errorName || !props.customErrorMessages) return '';
  return props.customErrorMessages[errorName] ?? '';
}

const customErrorMessage = computed<string>(() => {
  const errorState = getErrorState();
  return getErrorMessage(errorState);
});

const errorMessage = computed<VueI18n.TranslateResult | string>(() => {
  if (customErrorMessage.value) return customErrorMessage.value;

  if (!props.error?.required) {
    return `Please enter ${props.label.toLowerCase()}`;
  }

  return `Please enter a valid ${props.label.toLowerCase()}`;
});

// Methods
function openDropdown(): void {
  if (!props.items) return;
  open.value = true;
}

function closeDropdown(): void {
  open.value = false;
}

function toggleDropdown(): void {
  open.value = !open.value;
}

function onClick(): void {
  openDropdown();
}

function onInput(e: Event): void {
  const value = (e.target as HTMLInputElement).value;
  emit('input', value);

  // Close dropdown when user is typing
  open.value = false;
}

function onFocus(): void {
  emit('focus');
}

function onBlur(): void {
  emit('blur');
}

function itemSelected(item: Item): void {
  closeDropdown();
  emit('input', item.value);
}

return { __sfc: true,IconArrowDown, props, emit, open, errorExists, getErrorState, getErrorMessage, customErrorMessage, errorMessage, openDropdown, closeDropdown, toggleDropdown, onClick, onInput, onFocus, onBlur, itemSelected }
}

})